import React from 'react';
import Header from './components/header';
import Hero from './components/hero';
import 'animate.css';
import Start from './components/start';
import Details from './components/detailed';
import Advanced from './components/advanced';
import Example from './components/example';
import ShowCase from './components/showcase';
import Footer from './components/footer';

export default ()=> (
  <div style={{ overflow: "hidden" }}>
    <Header />
    <Hero />
    <Start />
    <Details />
    <Advanced />
    <ShowCase />
    <Example className="animated bounce delay-1s" />
    <Example className="animated flash delay-1s" />
    <Example className="animated pulse delay-1s" />
    <Example className="animated rubberBand delay-1s" />
    <Example className="animated shake delay-1s" />
    <Example className="animated swing delay-1s" />
    <Example className="animated tada delay-1s" />
    <Example className="animated jello delay-1s" />
    <Example className="animated heartBeat delay-1s" />
    <Example className="animated rotateIn delay-1s" />
    <Example className="animated zoomIn delay-1s" />
    <Footer />
  </div>
);

//import logo from './logo.svg';
/*import styled from 'styled-components';
import { RaosWrapper } from 'raos';
import 'animate.css';

const Item = styled.div`
  height: 100vh;
  background-color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  align-items: center;
`

function App() {
  //const [observe, setObserve] = useObserver(.5);
  return (
    <div>
      <Item color="violet">
        <h1>RAOS</h1>
      </Item>
      <Item color='crimson' >
        <RaosWrapper style={{ opacity: 0 }} className="animated fadeIn delay-2s" percent={10}>
          <h1>RAOS</h1>
        </RaosWrapper>
      </Item>
      <Item color="gold">
        <h1>RAOS</h1>
      </Item>
    </div>
  );
}

export default App;*/
